// Module-level mirror of the platform-admin org-view context, readable by MSW
// handlers (which run outside React). The Zustand store in store/orgContext.ts
// is the single source of truth and writes here on every change.
//
// Purpose: a central MSW read-only guard can reject mutations while a platform
// admin is viewing another org's dashboard (D-5 Ring 3 "transparent glass"
// read-only mode V1) without retrofitting every action button.

export type OrgViewSide = 'seller' | 'supply'

type OrgViewState = {
  mode: 'self' | 'platform_viewing'
  side: OrgViewSide | null
  orgId: string | null
  orgName: string | null
  orgType: string | null
  enteredByUserId: string | null
  enteredAt: string | null
}

const SELF: OrgViewState = {
  mode: 'self',
  side: null,
  orgId: null,
  orgName: null,
  orgType: null,
  enteredByUserId: null,
  enteredAt: null,
}

let current: OrgViewState = { ...SELF }

export function setOrgViewState(next: OrgViewState): void {
  current = next
}

export function clearOrgViewState(): void {
  current = { ...SELF }
}

export function getOrgViewState(): OrgViewState {
  return current
}

export function isPlatformViewing(): boolean {
  return current.mode === 'platform_viewing'
}

export function isPlatformViewMutationPath(pathname: string): boolean {
  const path = pathname.toLowerCase()
  return (
    path.includes('/seller/') ||
    path.includes('/supply/') ||
    path.includes('/messaging/') ||
    path.includes('/drive/attachments/')
  )
}
